import React from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import {
  EMPTY_STRING,
  MULTI_SELECT_LIMIT_TAGS,
} from "../utils/constants";
import { formClasses } from "../styles/AutocompleteStyles";
import { PriorityEnum } from "../utils/Enum.types";
interface Props {
  onChange: (newValue: PriorityEnum[]) => void;
  autoCompleteValue: PriorityEnum[];
  handleClear: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  label?: string;
  placeholder?: string;
}
const MultipleJunctionPrioritySelect = ({
  onChange,
  handleClear,
  onKeyDown,
  autoCompleteValue,
  label,
  placeholder,
}: Props) => {
  return (
    <>
      <div className="multi-select-autocomplete">
        <Autocomplete
          className={formClasses.inputRoot}
          options={Object.values(PriorityEnum).filter(
            (prior) => prior !== PriorityEnum.ALL
          )}
          limitTags={MULTI_SELECT_LIMIT_TAGS}
          multiple
          onChange={(e, newValue) => {
            onChange(newValue);
          }}
          renderOption={(props, option) => {
            const selectedSuppliers = autoCompleteValue.map((value) => value);

            const checked = selectedSuppliers.includes(option as PriorityEnum);

            return (
              <li {...props} key={option as PriorityEnum}>
                <Checkbox style={{ marginRight: 8 }} checked={checked} />
                {option as PriorityEnum}
              </li>
            );
          }}
          onKeyDown={onKeyDown}
          openOnFocus
          forcePopupIcon
          value={autoCompleteValue}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              className={formClasses.formControlRoot}
              label={label}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              placeholder={autoCompleteValue.length ? EMPTY_STRING : placeholder}
            />
          )}
        />
      </div>

      {/* <LoadingModal flag={loading} /> */}
    </>
  );
};

export default MultipleJunctionPrioritySelect;
